import type { SVGProps } from 'react';
const SvgShortcut = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    height={16}
    fill="none"
    width={16}
    {...props}
  >
    <rect height={15} fill="#fff" width={13} rx={3.5} x={1.5} y={0.5} />
    <rect stroke="currentColor" height={15} width={13} rx={3.5} x={1.5} y={0.5} />
    <path d="M9.977 2.864 7.165 13.313H6.027l2.812-10.45z" fill="currentColor" />
  </svg>
);
export default SvgShortcut;
